module.exports = __webpack_public_path__ + "static/media/54_1135.d852e1b8.webp";